export class Teams {
  constructor({
    teamsId = 0,
    orderID = 0,
    connectionType = null,
    hardware = null,
    teamsRows = [],
    configType = 'setupConfig',
    hasOnGoingTeamConfig = false
  } = {}) {
    this.teamsId = teamsId;
    this.orderID = orderID;
    this.connectionType = connectionType;
    this.hardware = hardware;
    this.teamsRows = teamsRows;
    this.configType = configType;
    this.hasOnGoingTeamConfig = hasOnGoingTeamConfig;
  }
}
export function createNewTeams(data) {
  return Object.freeze(new Teams(data));
}
